module.exports = __webpack_public_path__ + "static/img/goods-50.66dc074.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/s29/pop/goods-50.png
// module id = JvZL
// module chunks = 2